var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.681 9.07167C26.0241 9.07167 25.3672 8.46667 25.3672 7.86161V2.81954C25.3672 2.2145 26.0241 1.60938 26.681 1.60938C27.3379 1.60938 27.9947 2.2145 27.9947 2.81954V7.86161C27.9947 8.46667 27.5568 9.07167 26.681 9.07167Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3216 9.07167C12.6647 9.07167 12.0078 8.46667 12.0078 7.86161V2.81954C12.0078 2.2145 12.6647 1.60938 13.3216 1.60938C13.9785 1.60938 14.6354 2.2145 14.6354 2.81954V7.86161C14.4164 8.46667 13.9785 9.07167 13.3216 9.07167Z",
    fill: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5287 37.1999H10.4776C4.78464 37.1999 1.28125 33.7138 1.28125 28.0489V13.0855C1.28125 7.63851 4.78464 4.15234 10.4776 4.15234H29.5287C32.3752 4.15234 34.7838 5.02394 36.3165 6.54911C37.8493 8.07427 38.7251 10.471 38.7251 13.0855V28.2669C38.7251 33.9318 35.2217 37.1999 29.5287 37.1999ZM10.4776 6.54911C6.09841 6.54911 3.68983 9.16362 3.68983 13.3033V28.2669C3.68983 32.6245 6.09841 34.8033 10.4776 34.8033H29.5287C33.9079 34.8033 36.3165 32.4066 36.3165 28.2669V13.0855C36.3165 11.1246 35.6596 9.38153 34.5648 8.29213C33.47 7.20272 31.7183 6.54911 29.5287 6.54911H10.4776Z",
    fill: "#A8A8A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/calendar-gray.b0d09fb92a5d44a30bec5e811a72541b.svg";
export { ForwardRef as ReactComponent };